import bitcoin from "./bitcoin";
import binancecoin from "./binance";
import cardano from "./cardano";
import ethereum from "./ethereum";
import polkadot from "./polkadot";
import tether from "./tether";
import dogecoin from "./dogecoin";
import litecoin from "./litecoin";
import chainlink from "./chainlink";
import shibaInu from "./shibaInu";
import tron from "./tron";
import dai from "./dai";
import uniswap from "./uniSwap";
import wink from "./wink";
import sushi from "./sushiSwap";
import filecoin from "./filecoin";
import ripple from "./ripple";
// import paxgold from "./ paxgold";
import harmony from "./harmony";
import tezos from "./tezos";
import bitcoinCash from "./bitcoinCash";

export default {
  bitcoin,
  binancecoin,
  cardano,
  ethereum,
  polkadot,
  tether,
  dogecoin,
  litecoin,
  chainlink,
  shibaInu,
  tron,
  dai,
  uniswap,
  wink,
  sushi,
  filecoin,
  ripple,
  // paxgold,
  harmony,
  tezos,
  bitcoinCash,
};
